/**
 * Gross-profit math for the margin tool. GP% is margin on the SELLING price
 * (the dental-distribution convention), not markup on cost:
 *
 *   GP%   = (price − cost) / price × 100
 *   price = cost / (1 − GP%/100)
 *
 * All math runs through decimal.js — never native Number — so the prices we
 * post to Spire match what the rep saw to the cent.
 */
import { Decimal } from 'decimal.js';
/** GP% earned at `price` given `cost`. Returns 0 when price ≤ 0. */
export function gpPercent(price, cost) {
    const p = new Decimal(price);
    const c = new Decimal(cost);
    if (p.lte(0))
        return new Decimal(0);
    return p.minus(c).div(p).times(100);
}
/**
 * Selling price that yields a target `marginPct` GP given `cost`. Margins ≥ 100%
 * are unreachable (would require infinite price) → returns 0 so the caller can
 * guard/clamp; a 0%/negative margin just returns cost or below.
 */
export function priceForMarginPct(cost, marginPct) {
    const c = new Decimal(cost);
    const m = new Decimal(marginPct);
    const denom = new Decimal(1).minus(m.div(100));
    if (denom.lte(0))
        return new Decimal(0);
    return c.div(denom);
}
/** Gross profit dollars at `price` given `cost`. */
export function grossProfit(price, cost) {
    return new Decimal(price).minus(new Decimal(cost));
}
/** Round to cents (2 dp, half-up) for display/posting. */
export function toMoney(value) {
    return new Decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP).toFixed(2);
}
//# sourceMappingURL=margin.js.map